export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';
export const SET_IS_LOGGED_IN = 'SET_IS_LOGGED_IN';
export const SHOW_ALERT = 'SHOW_ALERT';
export const HIDE_ALERT = 'HIDE_ALERT';
export const SET_COMPANIES = 'SET_COMPANIES';
export const SET_REMINDER_TYPES = 'SET_REMINDER_TYPES';
export const SET_CURRENT_COMPANY = 'SET_CURRENT_COMPANY';
export const SET_CURRENT_COMPANY_OPERATORS = 'SET_CURRENT_COMPANY_OPERATORS';
export const SET_CURRENT_OPERATOR = 'SET_CURRENT_OPERATOR';
export const SET_CURRENT_ROOM = 'SET_CURRENT_ROOM';
export const SET_CURRENT_ROOMS_BY_FILTER = 'SET_CURRENT_ROOMS_BY_FILTER';
export const SET_CURRENT_ROOMS_BY_SEARCH_TERM = 'SET_CURRENT_ROOMS_BY_SEARCH_TERM';
export const SET_CURRENT_ROOM_FILTER = 'SET_CURRENT_ROOM_FILTER';
export const SET_CURRENT_ROOM_SEARCH_TERM = 'SET_CURRENT_ROOM_SEARCH_TERM';
export const SET_TOTAL_UNREAD_COUNT = 'SET_TOTAL_UNREAD_COUNT';
export const SET_DOCUMENT_TITLE_BASE = 'SET_DOCUMENT_TITLE_BASE';
export const SET_CURRENT_MESSAGES = 'SET_CURRENT_MESSAGES';
export const SET_WORK_HOURS_SCHEDULER_REASONS = 'SET_WORK_HOURS_SCHEDULER_REASONS';
export const SET_WORK_HOURS_SCHEDULER_IS_WORKING = 'SET_WORK_HOURS_SCHEDULER_IS_WORKING';
export const SET_WORK_HOURS_SCHEDULER_CAN_SWITCH_OFF = 'SET_WORK_HOURS_SCHEDULER_CAN_SWITCH_OFF';
export const SET_NEW_VERSION_AVAILABLE = 'SET_NEW_VERSION_AVAILABLE';
export const SET_MOBILE_ROOM_MENU_ENABLED = 'SET_MOBILE_ROOM_MENU_ENABLED';
export const SET_MOBILE_ROOM_INFO_ENABLED = 'SET_MOBILE_ROOM_INFO_ENABLED';
export const SET_CASE_CLOSE_REASON = 'SET_CASE_CLOSE_REASON';
